import books from '@/assets/images/icons/books.png'
import chat from '@/assets/images/icons/blue chat bubble.png'
import dollarHand from '@/assets/images/icons/hand holding dollar coin.png'
import gear from '@/assets/images/icons/gear icon with neon.png'
import goldCoin from '@/assets/images/icons/gold dollar coin.png'
import payment from '@/assets/images/icons/payment processing gateway.png'
import calendar from '@/assets/images/icons/red calendar.png'
import research from '@/assets/images/icons/ai-powered financial research tools.png'

const icons: Record<string, string> = {
  quickbooks: goldCoin,
  qb: goldCoin,
  slack: chat,
  stripe: dollarHand,
  payments: payment,
  'google-calendar': calendar,
  calendar,
  dropbox: books,
  zapier: research,
  default: gear,
}

export function integrationIcon(idOrKey?: string | null) {
  if (!idOrKey) return icons.default
  const key = String(idOrKey).toLowerCase().trim()
  if (icons[key]) return icons[key]
  const file = key.split('/').pop()?.replace(/\.[a-z0-9]+$/i, '') || ''
  const normalized = file.replace(/[_-]+/g, ' ')
  if (normalized.includes('dollar') || normalized.includes('gold')) return goldCoin
  if (normalized.includes('chat') || normalized.includes('slack')) return chat
  if (normalized.includes('hand holding')) return dollarHand
  if (normalized.includes('calendar')) return calendar
  if (normalized.includes('book')) return books
  return icons.default
}
